export default __webpack_public_path__ + "static/media/cross-icon.49079730.svg";